import custom from './custom'
import dark from './dark'
import defaultTheme from './default'
import light from './light'

export default { dark, light, defaultTheme, custom }
